import { useMonarchRule } from "../MonarchRulesProvider";
import {
  LogistrationPageRedesignProps,
  LogistrationPageRedesignResult,
  LogistrationPageRedesignVariant,
  UseLogistrationPageRedesign,
  UseLogistrationPageRedesignConfig,
} from "./types";

const CUSTOM_RULE_ID = "logistrationDesign";

const useLogistrationPageRedesign: UseLogistrationPageRedesign = () => {
  const { isLoading, value } = useMonarchRule<{
    data: LogistrationPageRedesignProps;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value) {
    return {
      isLoading: true,
      variant: "control",
    };
  }

  const variant: LogistrationPageRedesignVariant = value.data.variant;

  return {
    isLoading: false,
    variant,
    data: value.data,
  };
};

export default useLogistrationPageRedesign;
